<p-dialog
  [header]="headerText"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [baseZIndex]="10000"
  [closable]="false"
  styleClass="bl-modal"
  [positionTop]="65"
  [positionLeft]="390"
  [(visible)]="opened"
>
  <p *ngIf="user; else elseBlock">
    {{ contentText }} <strong>{{ user.mail }}</strong
    >?
  </p>
  <ng-template #elseBlock>{{ contentText }}</ng-template>
  <p-footer>
    <button type="button" pButton label="Cancel" (click)="cancel()"></button>
    <button
      type="button"
      pButton
      [label]="submitBtnText"
      class="ui-button-secondary"
      (click)="submit()"
    ></button>
  </p-footer>
</p-dialog>
